import { render } from "./WrongCodes.vue?vue&type=template&id=1c395c0b&bindings={\"wrongCodes\":\"setup\",\"currentCode\":\"setup\"}"
import script from "./WrongCodes.vue?vue&type=script&lang=js"
export * from "./WrongCodes.vue?vue&type=script&lang=js"

import "./WrongCodes.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script